import { getToken, returnError } from './helperFunc';
import { remoteMachineAction, remoteActivateAction, machineMonitorAction, stopMachineAction , remoteFetchMachineAction, fetchInvoiceAction, downloadInvoiceAction, machineMonitorEnabledAction, paymentHistoryAction, sendInvoiceReminderAction, getReminderAction } from './requestEndpoints';

import { LOGOUT_SUCCESS } from './userReducer';

const SET_REMOTE_LOADING = 'SET_REMOTE_LOADING';
const CLEAR_REMOTE_ERROR = 'CLEAR_REMOTE_ERROR';

const SET_LOADING2 = 'SET_LOADING2';

const REMOTE_MACHINES_SUCCESS = 'REMOTE_MACHINES_SUCCESS';
const REMOTE_MACHINES_FAIL = 'REMOTE_MACHINES_FAIL';

const REMOTE_ACTIVATION_SUCCESS = 'REMOTE_ACTIVATION_SUCCESS';
const REMOTE_ACTIVATION_FAIL = 'REMOTE_ACTIVATION_FAIL';

const MACHINE_MONITOR_SUCCESS = 'MACHINE_MONITOR_SUCCESS';
const MACHINE_MONITOR_FAIL = 'MACHINE_MONITOR_FAIL';

const MACHINE_MONITOR_ENABLED_SUCCESS = 'MACHINE_MONITOR_ENABLED_SUCCESS';
const MACHINE_MONITOR_ENABLED_FAIL = 'MACHINE_MONITOR_ENABLED_FAIL';

const STOP_MACHINE_SUCCESS = 'STOP_MACHINE_SUCCESS';
const STOP_MACHINE_FAIL = 'STOP_MACHINE_FAIL';

const REMOTE_FETCH_MACHINES_SUCCESS = 'REMOTE_FETCH_MACHINES_SUCCESS';
const REMOTE_FETCH_MACHINES_FAIL = 'REMOTE_FETCH_MACHINES_FAIL';

const FETCH_INVOICE_SUCCESS = 'FETCH_INVOICE_SUCCESS';
const FETCH_INVOICE_FAIL = 'FETCH_INVOICE_FAIL';
const FETCH_PAYMENT_HISTORY_SUCCESS = 'FETCH_PAYMENT_HISTORY_SUCCESS';
const FETCH_PAYMENT_HISTORY_FAIL = 'FETCH_PAYMENT_HISTORY_FAIL';

const SET_INVOICE_LOADING = 'SET_INVOICE_LOADING';
const CLEAR_INVOICE_ERROR = 'CLEAR_INVOICE_ERROR';

// FOR REMOTE ACTIVATION

export const remoteMachine = (operatorId, outletId, coin) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_REMOTE_ERROR });
		dispatch({ type: SET_REMOTE_LOADING });

		const { user } = getState();
		// console.log('user', user);
		const token = getToken(user);

		const { data } = await remoteMachineAction(operatorId, outletId, token, coin);

		dispatch({ type: REMOTE_MACHINES_SUCCESS, payload: data });
		// console.log(data);
	} catch (error) {
		dispatch({ type: REMOTE_MACHINES_FAIL, payload: returnError(error) });
	}
};

export const remoteFetchMachine = (operatorId, outletId, coin) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_REMOTE_ERROR });
		dispatch({ type: SET_REMOTE_LOADING });

		const { user } = getState();
		// console.log('user', user);
		const token = getToken(user);

		const { data } = await remoteFetchMachineAction(operatorId, outletId, token, coin);

		dispatch({ type: REMOTE_FETCH_MACHINES_SUCCESS, payload: data });
		// console.log(data);
	} catch (error) {
		dispatch({
			type: REMOTE_FETCH_MACHINES_FAIL, payload: returnError(error)
		});
	}
};

export const remoteActivate = (values) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_REMOTE_ERROR });
		dispatch({ type: SET_REMOTE_LOADING });

		const { user } = getState();
		// console.log('user', user);
		const token = getToken(user);

		const { data } = await remoteActivateAction(values, token);

		dispatch({ type: REMOTE_ACTIVATION_SUCCESS, payload: data });
		// console.log(data);
	} catch (error) {
		dispatch({ type: REMOTE_ACTIVATION_FAIL, payload: returnError(error) });
	}
};

export const machineMonitor = (values) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_REMOTE_ERROR });
		dispatch({ type: SET_REMOTE_LOADING });

		const { user } = getState();
		// console.log('user', user);
		const token = getToken(user);

		const { data } = await machineMonitorAction(values, token);

		dispatch({ type: MACHINE_MONITOR_SUCCESS, payload: data });
		// console.log(data);
	} catch (error) {
		dispatch({ type: MACHINE_MONITOR_FAIL, payload: returnError(error) });
	}
};

export const machineMonitorEnabled = (values) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_REMOTE_ERROR });
		dispatch({ type: SET_REMOTE_LOADING });

		const { user } = getState();
		// console.log('user', user);
		const token = getToken(user);

		const { data } = await machineMonitorEnabledAction(values, token);

		dispatch({ type: MACHINE_MONITOR_ENABLED_SUCCESS, payload: data });
		// console.log(data);
	} catch (error) {
		dispatch({ type: MACHINE_MONITOR_ENABLED_FAIL, payload: returnError(error) });
	}
};

export const stopWasherMachine = (values) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_REMOTE_ERROR });
		dispatch({ type: SET_LOADING2 });

		const { user } = getState();
		// console.log('user', user);
		const token = getToken(user);

		const { data } = await stopMachineAction(values, token);

		dispatch({ type: STOP_MACHINE_SUCCESS, payload: data });
		console.log(data);
	} catch (error) {
		dispatch({ type: STOP_MACHINE_FAIL, payload: returnError(error) });
	}
};

export const fetchInvoice = (operatorId, outletId, coin, status) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_INVOICE_ERROR });
		dispatch({ type: SET_INVOICE_LOADING });

		const { user } = getState();
		// console.log('user', user);
		const token = getToken(user);

		const { data } = await fetchInvoiceAction(operatorId, outletId, token, coin, status);

		dispatch({ type: FETCH_INVOICE_SUCCESS, payload: data });
		// console.log(data);
	} catch (error) {
		dispatch({ type: FETCH_INVOICE_FAIL, payload: returnError(error) });
	}
};

export const fetchPaymentHistory = (body = {}) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_INVOICE_ERROR });
		dispatch({ type: SET_INVOICE_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await paymentHistoryAction(body, token);

		dispatch({ type: FETCH_PAYMENT_HISTORY_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: FETCH_PAYMENT_HISTORY_FAIL, payload: returnError(error) });
	}
};

export const sendInvoiceReminder = (payload) => async (dispatch, getState) => {
	try {
		const { user } = getState();
		const token = getToken(user);

		const { data } = await sendInvoiceReminderAction(payload, token);

		return data;
	} catch (error) {
		return returnError(error);
	}
};

export const getReminder = () => async (dispatch, getState) => {
    try {
        const { user } = getState();
        const token = getToken(user);

        const { data } = await getReminderAction(token);

        return data;
    } catch (error) {
        return returnError(error);
    }
};

export const downloadInvoice = (invoiceNumber) => async (dispatch, getState) => {
	try {
		const { user } = getState();
		const token = getToken(user);

		const response = await downloadInvoiceAction(invoiceNumber, token);
		
		// Create blob and trigger download
		const blob = new Blob([response.data], { type: 'application/pdf' });
		const url = window.URL.createObjectURL(blob);
		const link = document.createElement('a');
		link.href = url;
		link.download = `invoice-${invoiceNumber}.pdf`;
		document.body.appendChild(link);
		link.click();
		link.remove();
		window.URL.revokeObjectURL(url);
		
		return { success: true };
	} catch (error) {
		console.error('Error downloading invoice:', error);
		return { success: false, error: returnError(error) };
	}
};

const initialState = {
	language: 'en',
	operator: null,
	error: null,
	loading: false,
	machineData: [],
	stopLoading: false,
	machineData2: [],
	invoiceData: [],
	paymentHistoryData: [],
};

export const remoteReducer = function (state = initialState, action) {
	switch (action.type) {
		// this is for fetching loading time setter
		case SET_REMOTE_LOADING:
			return {
				...state,
				loading: true,
				error: null,
			};

		case SET_INVOICE_LOADING:
			return {
				...state,
				loading: true,
				error: null,
			};

		case SET_LOADING2:
			return {
				...state,
				stopLoading: true,
				error: null,
			};

		case CLEAR_INVOICE_ERROR:
			return {
				...state,
				error: null,
			};

		case REMOTE_MACHINES_SUCCESS:
			// console.log('action.payload', action.payload);
			return {
				...state,
				machineData: action.payload.data,
				loading: false,
				error: null,
			};

		case FETCH_INVOICE_SUCCESS:
			// console.log('action.payload', action.payload);
			return {
				...state,
				invoiceData: action.payload.data,
				loading: false,
				error: null,
			};

		case FETCH_PAYMENT_HISTORY_SUCCESS:
			return {
				...state,
				paymentHistoryData: action.payload.data,
				loading: false,
				error: null,
			};
		
		case REMOTE_FETCH_MACHINES_SUCCESS:
		// console.log('action.payload', action.payload);
			return {
				...state,
				machineData2: action.payload.data,
				loading: false,
				error: null,
			};

		case REMOTE_ACTIVATION_SUCCESS:
			return {
				...state,
				paid: action.payload.data,
				loading: false,
				error: null,
				monitor: null,
				enabled: null,
			};

		case MACHINE_MONITOR_SUCCESS:
			return {
				...state,
				paid: null,
				monitor: action.payload.data,
				loading: false,
				error: null,
			};

		case MACHINE_MONITOR_ENABLED_SUCCESS:
			return {
				...state,
				paid: null,
				enabled: action.payload.data,
				loading: false,
				error: null,
			};

		case STOP_MACHINE_SUCCESS:
			// console.log('action.payload', action.payload);
			return {
				...state,
				paid: null,
				monitor: null,
				stop: action.payload.data,
				stopLoading: false,
				error: null,
				enabled: null,
			};

		case LOGOUT_SUCCESS:
			return initialState;

		case REMOTE_MACHINES_FAIL:
		case REMOTE_ACTIVATION_FAIL:
		case MACHINE_MONITOR_FAIL:
		case MACHINE_MONITOR_ENABLED_FAIL:
		case STOP_MACHINE_FAIL:
		case REMOTE_FETCH_MACHINES_FAIL:
		case FETCH_INVOICE_FAIL:
		case FETCH_PAYMENT_HISTORY_FAIL:
			return {
				machineData: state.machineData,
				machineData2: state.machineData2,
				invoiceData: state.invoiceData,
				loading: false,
				error: action.payload,
				stopLoading: false,
			};

		default:
			return state;
	}
};
